import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { User } from "@/CodegenTypes";

import { sumBy } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";

import { customMoment } from "@/main";
import { canSeeDdCompanyLevel } from "@/helpers/user/canSeeDdCompanyLevel";
import { canSeeTtCompanyLevel } from "@/helpers/user/canSeeTtCompanyLevel";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRootStore } from "@/store/pinia";
import { canSeeDdPopl } from "@/helpers/user/canSeeDdPopl";
import { canSeeTtPopl } from "@/helpers/user/canSeeTtPopl";
import { FEATURE_TOGGLES } from "@/config";
import { useTranslation } from "@/store/translation";



export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryReport',
  setup(__props) {

const store = useRootStore();
const { $t } = useTranslation();

const summaryReportQuery = FEATURE_TOGGLES.useV1Legacy
  ? queries.summaryReportLegacy
  : queries.summaryReport;

const { result: userResult, loading } = useQuery<{ user: User }>(summaryReportQuery, {
  userId: store.account?.userId,
}, {
  fetchPolicy: "cache-and-network",
});

const user = computed(() => {
  return userResult.value?.user;
})

const displayDateNow = computed(() => {
  return customMoment().format("DD MMM YYYY, hh:mm:ss A");

})

const seeCompanyLevel = computed(() => {
  if (!user.value) {
    return false;
  }
  return canSeeDdCompanyLevel(user.value) || canSeeTtCompanyLevel(user.value);
})

const seePoPl = computed(() => {
  if (!user.value) {
    return false;
  }

  return canSeeDdPopl(user.value) || canSeeTtPopl(user.value);
})

const showShareClaim = computed(() => {
  return seeCompanyLevel.value && (FEATURE_TOGGLES.useV1Legacy || seePoPl.value);
})

const shareClaimLabel = computed(() => {
  return FEATURE_TOGGLES.useV1Legacy ? "Share Claim" : "PO";
})

const totalNet = computed(() => {
  return sumBy(summaryReport.value, r => r.net || 0);
})

const summaryReport = computed(() => {
  return user.value?.summaryReport.map((row) => {
    const releaseMoment = customMoment(row.date);
    return {
      ...row,
      displayDate: releaseMoment.format("YYYY/MM/DD"),
      displayDay: releaseMoment.format("dddd"),
    };
  });
})
const totalNetBal = computed(() => {
  return sumBy(summaryReport.value, r => r.netBal || 0);
})


return { __sfc: true,store, $t, summaryReportQuery, userResult, loading, user, displayDateNow, seeCompanyLevel, seePoPl, showShareClaim, shareClaimLabel, totalNet, summaryReport, totalNetBal, formatDollar }
}

})